import { dateUtils } from "../utils/DateUtils";
import { AbstractEntityService } from "./AbstractEntityService";

export class RatePlanService extends AbstractEntityService {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }

    async findAll(propertyId) {
        const url = `${this.baseUrl}/properties/${propertyId}/ratePlans`;

        try {
            const ratePlans = await super.find(url);

            ratePlans.forEach(ratePlan => {
                ratePlan.restrictions?.forEach(restriction => {
                    dateUtils.parseTimestampsToDates(restriction);
                })
            });

            return ratePlans;
        } catch (error) {
            this.handleError(error, "Unable to load Rate Plans - please see server logs for more details");
        }
    }

    async create(propertyId, ratePlan) {
        const url = `${this.baseUrl}/properties/${propertyId}/ratePlans`;

        try {
            const payload = {...ratePlan};
            payload.restrictions?.forEach(restriction => dateUtils.parseDatesToTimestamps(restriction));

            const createdRatePlan = await super.create(url, payload);

            createdRatePlan.restrictions?.forEach(restriction => dateUtils.parseTimestampsToDates(restriction));

            return createdRatePlan;
        } catch (error) {
            this.handleError(error, "Unable to create Rate Plan - please see server logs for more details");
        }
    }

    async update(propertyId, ratePlan) {
        const url = `${this.baseUrl}/properties/${propertyId}/ratePlans/${ratePlan.id}`;

        try {
            const payload = {...ratePlan};
            payload.restrictions?.forEach(restriction => dateUtils.parseDatesToTimestamps(restriction));

            const updatedRatePlan = await super.update(url, payload);

            updatedRatePlan.restrictions?.forEach(restriction => dateUtils.parseTimestampsToDates(restriction));

            return updatedRatePlan;
        } catch (error) {
            this.handleError(error, `Unable to update Rate Plan - please see server logs for more details`);
        }
    }

    async delete(propertyId, ratePlanId) {
        const url = `${this.baseUrl}/properties/${propertyId}/ratePlans/${ratePlanId}`;

        try {
            return await super.delete(url);
        } catch (error) {
            this.handleError(error, `Unable to delete Rate Plan - please see server logs for more details`);
        }
    }

    async createRestriction(propertyId, ratePlanId, restriction) {
        const url = `${this.baseUrl}/properties/${propertyId}/ratePlans/${ratePlanId}/restrictions`;

        try {
            const payload = { ...restriction };
            dateUtils.parseDatesToTimestamps(payload);

            const createdRestriction = await super.create(url, payload);

            dateUtils.parseTimestampsToDates(createdRestriction);

            return createdRestriction;
        } catch (error) {
            this.handleError(error, `Unable to create restriction - please see server logs for more details`);
        }
    }

    async updateRestriction(propertyId, ratePlanId, restrictionId, restriction) {
        const url = `${this.baseUrl}/properties/${propertyId}/ratePlans/${ratePlanId}/restrictions/${restrictionId}`;

        try {
            const payload = { ...restriction };
            dateUtils.parseDatesToTimestamps(payload);

            const updatedRestriction = await super.update(url, payload);

            dateUtils.parseTimestampsToDates(updatedRestriction);

            return updatedRestriction;
        } catch (error) {
            this.handleError(error, `Unable to update restriction - please see server logs for more details`);
        }
    }

    async updateRestrictions(propertyId, ratePlanId, restrictions) {
        const url = `${this.baseUrl}/properties/${propertyId}/ratePlans/${ratePlanId}/restrictions`;

        try {
            const payload = [...restrictions];
            payload.forEach(restriction => dateUtils.parseDatesToTimestamps(restriction));

            const updatedRestrictions = await super.update(url, payload);

            updatedRestrictions.forEach(restriction => dateUtils.parseTimestampsToDates(restriction));

            return updatedRestrictions;
        } catch (error) {
            this.handleError(error, `Unable to update restrictions - please see server logs for more details`);
        }
    }

    async deleteRestriction(propertyId, ratePlanId, restrictionId) {
        const url = `${this.baseUrl}/properties/${propertyId}/ratePlans/${ratePlanId}/restrictions/${restrictionId}`;

        try {
            return await super.delete(url);
        } catch (error) {
            this.handleError(error, `Unable to delete restriction - please see server logs for more details`);
        }
    }
}
